import * as React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { Input, Checkbox } from "@progress/kendo-react-inputs";
import { Label } from "@progress/kendo-react-labels";
import SubmitButton from "components/common/SubmitButton";

const EditCurrency = (props) => {
  const ADD_NEW = props.type === "addNew";
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [submitAttempted, setSubmitAttempted] = React.useState(false);

  const validateForm = (values) => {
    const errors = {};
    if (
      ADD_NEW &&
      (!values.currencyCode || values.currencyCode.trim() === "")
    ) {
      errors.currencyCode = "Currency code is required";
    }

    if (!values.name || values.name.trim() === "") {
      errors.name = "Name is required";
    }

    return errors;
  };

  const handleFormSubmit = async (formData) => {
    setIsSubmitting(true);
    try {
      await props.onSubmit(formData);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog
      title={ADD_NEW ? "Add new Currency" : `Edit ${props?.item?.name}`}
      onClose={props.cancelEdit}
      width={600}
    >
      <Form
        onSubmit={handleFormSubmit}
        initialValues={{
          active: true,
          ...(!ADD_NEW && props.item),
        }}
        validator={validateForm}
        render={(formRenderProps) => (
          <>
            <div className="p-3 ps-4">
              <FormElement>
                <fieldset className={"k-form-fieldset"}>
                  {ADD_NEW && (
                    <div className="mb-2">
                      <Label className="label mt-1 w-100">
                        Currency Code&nbsp;
                      </Label>
                      <Field
                        className="mt-1"
                        name={"currencyCode"}
                        component={Input}
                        maxLength={3}
                      />
                      {submitAttempted &&
                        formRenderProps.errors?.currencyCode && (
                          <div className="fs-sm my-1 text-danger">
                            <i>{formRenderProps.errors.currencyCode}</i>
                          </div>
                        )}
                    </div>
                  )}
                  <div className="mb-2">
                    <Label className="label mt-1 w-100">Name&nbsp;</Label>
                    <Field className="mt-1" name={"name"} component={Input} />
                    {submitAttempted && formRenderProps.errors?.name && (
                      <div className="fs-sm my-1 text-danger">
                        <i>{formRenderProps.errors.name}</i>
                      </div>
                    )}
                  </div>
                  <div className="mb-3">
                    <Label className="label mt-1">Symbol&nbsp;</Label>
                    <Field className="mt-1" name={"symbol"} component={Input} />
                  </div>
                  <Field
                    name={"active"}
                    component={Checkbox}
                    label={"Active"}
                  />
                </fieldset>
              </FormElement>
            </div>
            <div className="dialog-footer">
              <button
                className="bgBtnSecondary common-btn me-2"
                onClick={props.cancelEdit}
                disabled={isSubmitting}
              >
                Cancel
              </button>
              <SubmitButton
                className="me-3"
                isLoading={isSubmitting}
                onClick={() => {
                  setSubmitAttempted(true);
                  formRenderProps.onSubmit();
                }}
                disabled={!formRenderProps.allowSubmit}
              >
                {ADD_NEW ? "Save" : "Update"}
              </SubmitButton>
            </div>
          </>
        )}
      />
    </Dialog>
  );
};

export default EditCurrency;
